(function () {
  'use strict';

  /* @ngdoc object
   * @name flyingScheduleReport
   * @description
   *
   */
  angular
    .module('flyingScheduleReport', [
      'ui.router'
    ]);
}());
